type FaqItemLike = {
  answer: string;
  children?: { question: string; answer: string }[];
};

const escapeHtml = (str: string) =>
  str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const buildFaqItemBodyHtml = (item: FaqItemLike): string => {
  const children = item.children ?? [];

  if (children.length === 0) return item.answer;

  const childBlocks = children
    .map(
      (child) =>
        `<details class="group"><summary class="cursor-pointer list-none flex items-center justify-between py-1"><span>${escapeHtml(
          child.question,
        )}</span></summary><p class="whitespace-pre-wrap pt-1">${escapeHtml(
          child.answer,
        )}</p></details>`,
    )
    .join("");

  return `${item.answer}<div class="mt-3 flex flex-col gap-2 pl-4 border-l-2 border-border/secondary">${childBlocks}</div>`;
};
